window.ZM_JSSDK &&
  window.ZM_JSSDK.setConfig({
    environment: process.env.BUILD_TYPE === 'prod' ? 'prod' : 'development',
		logLevel: process.env.NODE_ENV === 'production' ? 'error' : 'debug',
    trackWhiteList: [
      'https://air-class-gateway-fat-alhz.zmaxis.com',
      '//chat-gateway.zmlearn.com',
      '//app-gateway-tx.air-class.com',
      '//a-app-gateway.air-class.com',
    ],
  });

window.ZM_JSSDK &&
  window.ZM_JSSDK.setDefaults({
    appId: process.env.APPID,
    appVersion: '1.0.2',
    cSource: 'h5',
  });

/**
 *
 * 埋点sdk
 *
 * @export
 * @param {*} { eventId, eventParam }
 * @returns
 */
export function sendEvent({ eventId, eventParam }) {
  if (!window.ZM_JSSDK) return;
  window.ZM_JSSDK.sendEvent({
    eventId,
    eventParam,
    appId: process.env.APPID,
  });
}
